import React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image";
import Layout from "../components/layout/layout";
import { Link, graphql } from "gatsby";
import Seo from "../components/seo";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

export const Head = ({ data }) => {
  const seoData = data.portfolioJson.seo;
  const socialImg = getSrc(seoData?.socialImage);
  return (
    <Seo
      title={seoData?.title}
      description={seoData?.description}
      ogImage={socialImg}
      twitterImage={socialImg}
    />
  )
}

const PortfolioSingle = ({ data }) => {
  const allPortfolio = data.allPortfolioJson.edges
  const curCat = data.portfolioJson.categories;
  const curTitle = data.portfolioJson.title;
  const jsonData = data.portfolioJson.details;
  const bannerTitle = jsonData?.banner?.bannerTitle;
  const aboutTitle = jsonData?.about?.aboutTitle;
  const aboutDescripion = jsonData?.about?.aboutDescripion;
  const servicesTitle = jsonData?.about?.aboutServices?.servicesTitle;
  const servicesArray = jsonData?.about?.aboutServices?.services;
  const aboutFacts = jsonData?.about?.aboutFacts;
  const challengeTitle = jsonData?.challenge?.challengeTitle;
  const challengeDetails = jsonData?.challenge?.challengeDetails;
  const servicesTitlenew = jsonData?.services?.servicesTitlenew;
  const servicesDetails = jsonData?.services?.servicesDetails;


  const solutionTitle = jsonData?.solution?.solutionTitle;
  const solutionDetails = jsonData?.solution?.solutionDetails;
  const solutionSlider = jsonData?.solution?.solutionSlider;
  const otherimage = jsonData?.solution?.otherimage?.childImageSharp?.gatsbyImageData;
  const keyFeaturesmain = jsonData?.keyFeatures?.keyFeaturesMain || [];
  const factFiguresTitle = jsonData?.factFigures?.factFiguresTitle;
  const factFiguresDetails = jsonData?.factFigures?.factFiguresDetails;
  const ResultsTitle = jsonData?.Results?.ResultsTitle;
  const ResultsDescription = jsonData?.Results?.ResultsDescription;
  const ResultsDetails = jsonData?.Results?.ResultsDetails;
  const technologyTitle = jsonData?.technology?.technologyTitle;
  const technologyDescripion = jsonData?.technology?.technologyDescripion;
  const technologyDetails = jsonData?.technology?.technologyDetails;
  const appStoreImg = getImage(jsonData?.about?.appStoreImage);
  const appStoreUrl = jsonData?.about?.appStoreUrl;
  const googleStoreImg = getImage(jsonData?.about?.googleStoreImage);
  const googleStoreUrl = jsonData?.about?.googleStoreUrl;
  
  return (
    <>
      <Layout>
        <section className="section background-pattern d-flex align-items-center"> {/* style={{ backgroundImage: `url(${bannerImage})` }} */}
          <Container className="py-5 mt-lg-5">
            <div className="banner-content text-center py-lg-5">
              <h1 className="title mb-0" dangerouslySetInnerHTML={{ __html: bannerTitle }} />
            </div>
          </Container>
        </section>
        <section className="section bg-black case-about-section">
          <Container className="py-5">
            <div className="mb-0">
              <Row className="g-4" xs={1} md={1} lg={2}>
                <Col lg={3}>
                  <div className="pb-4 case-study-title-border">
                    <h2 className="mb-4 text-white title-border-sm">
                      {aboutTitle}
                    </h2>
                  </div>
                  <div>
                    <h3 className="fw-medium font-size-18 text-white">Category</h3>
                    <p className="font-size-16 mb-0 category-single-post">
                      {curCat?.map((category, index) =>
                        <span key={index} className="category text-white-75">{category} <i className="coma-sep"> , </i></span>
                      )}
                    </p>
                  </div>
                  {servicesArray?.length > 0 && (
                    <div className="mt-4">
                      <h3 className="fw-medium font-size-18 text-white">{servicesTitle}</h3>
                      <p className="font-size-16 mb-0 category-single-post">
                        {servicesArray?.map((services, index) =>
                          <span key={index} className="category text-white-75">{services} <i className="coma-sep"> , </i></span>
                        )}
                      </p>
                    </div>
                  )}
                </Col>
                <Col lg={9}>
                  <div className="ms-lg-5">
                    <div className="text-white-75 lead mb-0" dangerouslySetInnerHTML={{ __html: aboutDescripion }} />
                    <div className="d-flex align-items-center">
                      {appStoreImg ?
                        <div className="mt-4 me-3">
                          <a href={appStoreUrl} target="_blank" aria-label="App Store" rel="noreferrer">
                            <div className="store-image">
                              <GatsbyImage loading="lazy" image={appStoreImg} alt="banner_app_store" />
                            </div>
                          </a>

                        </div>
                        : null}

                      {googleStoreImg ?
                        <div className="mt-4">
                          <a href={googleStoreUrl} target="_blank" aria-label="Play Store" rel="noreferrer">
                            <div className="store-image">
                              <GatsbyImage loading="lazy" image={googleStoreImg} alt="banner_app_store" />
                            </div>
                          </a>
                        </div>
                        : null}
                    </div>

                    {/* <Row className="g-4 gx-5" xs={1} md={2} lg="auto">
                      <Col>
                        <h3 className="fw-medium font-size-18">{expertiseTitle}</h3>
                        <p className="font-size-16 mb-0 category-single-post">
                          {expMore ? expMore.map((expertise, index) => (
                            <span key={index} className="category">{expertise} <i className="coma-sep"> , </i></span>
                          )) : null}
                        </p>
                      </Col>
                      <Col className="d-flex">
                        <h3 className="fw-medium font-size-18 me-3 mb-0">{Industry?.catTitle}</h3>
                        <p className="font-size-16 mb-0 category-single-post">
                          {Industry?.category?.map((cat, index) => (
                            <span key={index} className="category">{cat} <i className="coma-sep"> , </i></span>
                          ))}
                        </p>
                      </Col>
                    </Row> */}
                  </div>
                </Col>
              </Row>
            </div>
            {jsonData?.about?.aboutFacts ?
              <div className="mt-5">
                <Row className="g-4" xs={1} md={2} lg={3}>
                  {
                    aboutFacts?.teamNo ?
                      <Col>
                        <div className="dark-box-1 equal-height">
                          <h3 className="text-white h4 mb-3">{aboutFacts?.teamTitle}</h3>
                          <div className="mb-4 case-study-title-border">
                            <p className="text-white title-border-sm h2"><span className="text-primary">{aboutFacts?.teamNo}</span></p>
                          </div>
                        </div>
                      </Col>
                      :
                      null
                  }

                  {aboutFacts?.weekNo ?
                    <Col>
                      <div className="dark-box-1 equal-height">
                        <h3 className="text-white h4 mb-3">{aboutFacts?.weekTitle}</h3>
                        <div className="mb-4 case-study-title-border">
                          <p className="text-white title-border-sm h2"><span className="text-primary">{aboutFacts?.weekNo}</span></p>
                        </div>
                      </div>
                    </Col> : null}

                  {aboutFacts?.monthNo ?
                    <Col>
                      <div className="dark-box-1 equal-height">
                        <h3 className="text-white h4 mb-3">{aboutFacts?.mpnthTitle}</h3>
                        <div className="mb-4 case-study-title-border">
                          <p className="text-white title-border-sm h2"><span className="text-primary">{aboutFacts?.monthNo}</span></p>
                        </div>
                      </div>
                    </Col> :
                    null
                  }
                </Row>
              </div> : null}
          </Container>
        </section>
        <section className="section challanges-section">
          <Container className="py-5">
            {jsonData?.services ?
              <div className="p-4 p-lg-5">
                <Row className="g-4">
                  <Col lg={3}>
                    <div className="mb-0 case-study-title-border sticky-section">
                      <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: servicesTitlenew }} />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <ul className="ps-0 ps-lg-5">
                      {servicesDetails?.map((services, index) => (
                        <li key={index} className="mb-3 lead d-flex">
                          <span className="me-2 mt-1 text-primary">
                            <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                          </span>
                          <div
                            className="mb-0" dangerouslySetInnerHTML={{ __html: services?.servicesName }} />
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </div> : null}

            {jsonData?.challenge ?
              <div className="dark-box-1 p-4 p-lg-5 mt-5">
                <Row className="g-4">
                  <Col lg={3}>
                    <div className="mb-0 case-study-title-border sticky-section">
                      <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: challengeTitle }} />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <ul className="ps-0 ps-lg-5">
                      {challengeDetails?.map((challenge, index) => (
                        <li key={index} className="mb-3 lead d-flex">
                          <span className="me-2 mt-1 text-primary">
                            <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                          </span>
                          <div
                            className="mb-0" dangerouslySetInnerHTML={{ __html: challenge?.challengeName }} />
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </div> : null}


            {jsonData?.solution ?
              <>
                <div className="mt-5">
                  <div className="0dark-box-1 p-4 p-lg-5">
                    <Row className="g-4">
                      <Col lg={3}>
                        <div className="mb-0 case-study-title-border sticky-section">
                          <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: solutionTitle }} />
                        </div>
                      </Col>
                      <Col lg={9}>
                        <ul className="ps-0 ps-lg-5">
                          {solutionDetails?.map((solution, index) => (
                            <li className="mb-3 lead d-flex" key={index}>
                              <span className="me-2 mt-1 text-primary">
                                <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                              </span>
                              <div
                                className="mb-0" dangerouslySetInnerHTML={{ __html: solution?.solutionName }} />
                            </li>
                          ))}
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>



                <div className="mt-5 pb-4">
                  {solutionSlider ?
                    <Swiper
                      modules={[Navigation, Pagination]}
                      slidesPerView={"auto"}
                      spaceBetween={50}
                      navigation={true}
                      pagination={{
                        clickable: true,
                      }}
                      className="solution-slider"
                    >
                      {solutionSlider?.map((solution, index) => {
                        const imageSolu = getImage(solution.images);
                        return (
                          <SwiperSlide key={index}>
                            <GatsbyImage loading="lazy" image={imageSolu} alt="solution" objectFit="contain" />
                          </SwiperSlide>
                        )
                      })}
                    </Swiper>
                    :
                    <GatsbyImage loading="lazy" image={otherimage} alt="solution" objectFit="contain" />}
                </div>




              </> : null}
            {jsonData?.keyFeatures ?
              <>
                {keyFeaturesmain.map((keyFeaturesmain, index) => (
                  <div className="mt-5" key={index}>
                    <div className="dark-box-1 p-4 p-lg-5">
                      <Row className="g-4">
                        <Col lg={3}>
                          <div className="mb-0 case-study-title-border sticky-section">
                            <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: keyFeaturesmain.keyFeaturesTitle }} />
                            {keyFeaturesmain.keyFeaturesDescription ? <p className="mb-0" dangerouslySetInnerHTML={{ __html: keyFeaturesmain.keyFeaturesDescription }} /> : null}
                          </div>
                        </Col>
                        <Col lg={9}>
                          <ul className="ps-0 ps-lg-5">
                            {keyFeaturesmain.keyFeaturesDetails?.map((keyFeatures, index) => (
                              <li className="mb-3 lead d-flex" key={index}>
                                <span className="me-2 mt-1 text-primary">
                                  <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                                </span>
                                <div
                                  className="mb-0" dangerouslySetInnerHTML={{ __html: keyFeatures?.keyFeaturesName }} />
                              </li>
                            ))}
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ))}
              </>
              : null}
            {jsonData?.Results ?
              <div className="mt-5">
                <div className="dark-box-1 p-4 p-lg-5">
                  <Row className="g-4">
                    <Col lg={3}>
                      <div className="mb-0 case-study-title-border sticky-section">
                        <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: ResultsTitle }} />
                        {ResultsDescription ? <p className="mb-0" dangerouslySetInnerHTML={{ __html: ResultsDescription }} /> : null}
                      </div>
                    </Col>
                    <Col lg={9}>
                      <ul className="ps-0 ps-lg-5">
                        {ResultsDetails?.map((Results, index) => (
                          <li className="mb-3 lead d-flex" key={index}>
                            <span className="me-2 mt-1 text-primary">
                              <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                            </span>
                            <div
                              className="mb-0" dangerouslySetInnerHTML={{ __html: Results?.ResultsName }} />
                          </li>
                        ))}
                      </ul>
                    </Col>
                  </Row>
                </div>
              </div>
              : null}

            {jsonData?.factFigures ?
              <div className="mt-5">
                <div className="dark-box-1 p-4 p-lg-5">
                  <Row className="g-4">
                    <Col lg={3}>
                      <div className="mb-0 case-study-title-border">
                        <h2 className="mb-4 title-border-sm" dangerouslySetInnerHTML={{ __html: factFiguresTitle }} />
                      </div>
                    </Col>
                    <Col lg={9}>
                      <ul className="ps-0 ps-lg-5">
                        {factFiguresDetails?.map((factFigures, index) => (
                          <li className="mb-3 lead d-flex" key={index}>
                            <span className="me-2 mt-1 text-primary">
                              <i className="zmdi zmdi-check-circle zmdi-hc-fw font-size-24"></i>
                            </span>
                            {factFigures?.factFiguresName}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  </Row>
                </div>
              </div> : null}
            {jsonData?.showtable ?
              <>

                <div className="mt-5">
                  <div className="dark-box-1 p-4 p-lg-5">
                    <Row className="g-4">
                      <Col lg={3}>
                        <div className="mb-0 case-study-title-border sticky-section">
                          <h2 className="mb-4 title-border-sm">Prior vs Post <span class='text-primary'>Migration</span></h2>
                        </div>
                      </Col>
                      <Col lg={9}>
                        <div class="custom-table ps-0 ps-lg-5">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th class="font-size-20 bg-success-light">Metric</th>
                                  <th class="font-size-20 bg-success-light">Before migration</th>
                                  <th class="font-size-20 bg-success-light">After migration</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-start">
                                    <strong>Network Capacity</strong> </td>
                                  <td class="text-start">1 Gbps</td>
                                  <td class="text-start">10+ Gbps (scalable)</td>
                                </tr>
                                <tr>
                                  <td class="text-start"><strong>Peak Traffic Handling</strong></td>
                                  <td class="text-start">30% of expected load</td>
                                  <td class="text-start">100% of expected load</td>
                                </tr>
                                <tr>
                                  <td class="text-start"><strong>DDoS Protection</strong></td>
                                  <td class="text-start">Limited</td>
                                  <td class="text-start">AWS Shield protection</td>
                                </tr>
                                <tr>
                                  <td class="text-start"><strong>Uptime</strong></td>
                                  <td class="text-start">99.5%</td>
                                  <td class="text-start">99.99%</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

              </>
              :
              null}

          </Container>
        </section>
        {
          jsonData?.technology ?
            <section className="section bg-light">
              < Container className="py-5" >
                <div className="mb-5 pb-1">
                  <h2 className={technologyDescripion ? "mb-4" : "mb-0"} dangerouslySetInnerHTML={{ __html: technologyTitle }} />
                  {technologyDescripion ? <p className="max-width-950 lead mb-0">{technologyDescripion}</p> : null}
                </div>
                <Row className="g-4" xs={1} md={3} lg={technologyDetails?.length <= 4 ? 4 : 5}>
                  {technologyDetails?.map((technology, index) => (
                    <Col key={index}>
                      <div className="dark-box-2 text-center equal-height">
                        {/* <i className={`${technology?.techIcon} case-studies-sprite-icon icon-size-70 mb-3`}></i> */}
                        <p className="mb-2 font-size-14 text-muted">{technology?.techName}</p>
                        <h3 className="h5 fw-normal mb-0">{technology?.techDesc}</h3>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container >
            </section >
            : null}
        {allPortfolio.filter(portfolio =>
          portfolio.node.categories?.some(i => curCat.includes(i)) &&
          portfolio.node.title !== curTitle
        ).length > 0 && (
            <section className="section ">
              <Container className="py-5">
                <div className="mb-5 pb-1">
                  <h2 className="mb-4">Have a look at<br />Our <span className="text-primary">success stories</span></h2>
                  <p className="max-width-950 lead">Over the years, Peerbits have delivered several customized solutions to their clients across the globe. You can get a closer look at few of such success stories here.</p>
                </div>
                <Row xs={1} lg={3} className="g-4">
                  {allPortfolio
                    .filter(portfolio => portfolio.node.categories?.some(i => curCat.includes(i)) && portfolio.node.title !== curTitle)
                    .map((portfolio, index) => {
                      const imagePortf = getImage(portfolio.node.featured);
                      if (index < 3) {
                        return (
                          <Col key={index}>
                            <Link to={`/case-studies/${portfolio.node.slug}.html`} className="blog-list-card single">
                              <div className="blog-image">
                                <GatsbyImage loading="lazy" width={416} height={250} image={imagePortf} alt="featured" />
                              </div>
                              <div className="blog-list-content mt-4">
                                <h2 className="blog-title h5 fw-normal">{portfolio.node.title}</h2>
                              </div>
                            </Link>
                          </Col>)
                      }
                      else {
                        return null;
                      }
                    })}
                </Row>
                <div className="text-center mt-5 pt-5">
                  <Link to="/works.html" className="btn btn-link">
                    <span>View more case studies</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                  </Link>
                </div>
              </Container>
            </section>
          )}
      </Layout >
    </>
  )
}
export default PortfolioSingle;
export const PortfSingleData = graphql`
query PortfolioSingleData($slug: String!) {
  allPortfolioJson {
    edges {
      node {
        id
        slug
        title
        excerpt
        categories
        featured {
          childImageSharp {
            gatsbyImageData(width: 416, height: 250)
          }
        }
      }
    }
  }
  portfolioJson(slug: {eq: $slug}) {
    id
    title
    categories
    seo {
      title
      description
      socialImage {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
    details {
      banner {
        bannerTitle
      }
      about {
        aboutTitle
        aboutDescripion
        appStoreUrl
        appStoreImage {
          childImageSharp {
            gatsbyImageData
          }
        }
        googleStoreUrl
        googleStoreImage {
          childImageSharp {
            gatsbyImageData
          }
        }
        aboutServices {
          servicesTitle
          services
        }
        aboutFacts {
          teamNo
          teamTitle
          weekNo
          weekTitle
          monthNo
          mpnthTitle
        }
      }
      services {
        servicesTitlenew
        servicesDetails {
          servicesName
        }
      }
      challenge {
        challengeTitle
        challengeDetails {
          challengeName
        }
      }
      solution {
        solutionTitle
        solutionDetails {
          solutionName
        }
          otherimage{
          childImageSharp {
              gatsbyImageData
            }
          }
        solutionSlider {
          images {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      keyFeatures {
        keyFeaturesMain {
          keyFeaturesTitle
          keyFeaturesDescription
          keyFeaturesDetails {
            keyFeaturesName
          }
        }
      }
      Results {
        ResultsTitle
        ResultsDescription
        ResultsDetails {
          ResultsName
        }
      }
      factFigures {
        factFiguresTitle
        factFiguresDetails {
          factFiguresName
        }
      }
      technology {
        technologyTitle
        technologyDescripion
        technologyDetails {
          techIcon
          techName
          techDesc
        }
      }
      showtable
    }
  }
}`
